import {
  FINISH_POKA_CHECKLIST_FAIL,
  FINISH_POKA_CHECKLIST_START,
  FINISH_POKA_CHECKLIST_SUCCESS,
  GET_POKA_CHECKLIST_FAIL,
  GET_POKA_CHECKLIST_START,
  GET_POKA_CHECKLIST_SUCCESS,
  START_POKA_CHECKLIST_FAIL,
  START_POKA_CHECKLIST_START,
  START_POKA_CHECKLIST_SUCCESS,
} from './constants';

import { API_URL } from '@shared/constants/config';
import { GET, PUT, REST_API } from '@shared/constants/rest-api';
import getQueryString from '@shared/utils/get-query-string';

const headers = {
  Accept: '*/*',
  'Content-Type': 'application/json',
};

const defaultToken = '';

export const getChecklistInfo = (blockId, studyPlanId) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL}/block/checklist/${blockId}${getQueryString({ studyPlanId })}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  types: [GET_POKA_CHECKLIST_START, GET_POKA_CHECKLIST_SUCCESS, GET_POKA_CHECKLIST_FAIL],
});

export const startChecklist = (blockId, onSuccess) => ({
  type: REST_API,
  method: PUT,
  url: `${API_URL}/block/${blockId}/checklist/start`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body: {},
  onSuccess,
  types: [START_POKA_CHECKLIST_START, START_POKA_CHECKLIST_SUCCESS, START_POKA_CHECKLIST_FAIL],
});

export const finishChecklist = (blockId, onSuccess) => ({
  type: REST_API,
  method: PUT,
  url: `${API_URL}/block/${blockId}/checklist/finish`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body: {},
  onSuccess,
  types: [FINISH_POKA_CHECKLIST_START, FINISH_POKA_CHECKLIST_SUCCESS, FINISH_POKA_CHECKLIST_FAIL],
});
